import { HeaderLabelChipStyle } from '@tableau/catalog-ui-temp';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ISanitizer } from '~commonInfra/utils/Sanitize';
import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { LabelWrapper } from '~src/catalog/CatalogLabelsHookHelper';
import { ItemDescription } from '~src/spacesPlatform/components/header/HeaderItemDescription';
import { ModifiedDateMetadata, OwnerMetadata } from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import { ActionsMenuIcon, DetailButtonIcon, FavoriteToggleWithCountsIcon } from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';

import { DraftWorkbookSpaceProps } from '../../drafts/types/DraftsTypes';
import { ConnectedExtractMetadata } from '../../extractTask/components/spaces/header/ExtractMetadata';
import { ConnectedExtractTasksMetadata } from '../../extractTask/components/spaces/header/ExtractTasksMetadata';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';
import { EditWorkbookAction } from '../entityActions/EditWorkbookAction';
import { IWorkbookActions } from '../ServerApi/types/IWorkbookActions';
import { WorkbookSpaceHeaderDraftBanner } from './WorkbookSpaceHeaderDraftBanner';

export interface WorkbookSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'workbook'>;
  readonly availableActions: IWorkbookActions;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly sanitizer: ISanitizer;
  readonly catalogingOnSiteEnabled: boolean;
  readonly draft?: DraftWorkbookSpaceProps;
}

export function WorkbookSpaceHeader(props: WorkbookSpaceHeaderProps): JSX.Element {
  return <ConnectedSpaceHeader
    item={props.item}
    availableActions={props.availableActions}
    nameRowIcons={
      <React.Fragment>
        {FavoriteToggleWithCountsIcon({
          item: props.item,
          addToFavorites: props.addToFavorites,
          removeFromFavorites: props.removeFromFavorites,
        })}
        {DetailButtonIcon(props.item, props.openDetail)}
        {ActionsMenuIcon(props.item)}
      </React.Fragment>
    }
    metadataRow={
      <React.Fragment>
        {OwnerMetadata(props.item.owner, props.urls)}
        {ModifiedDateMetadata(props.item.updatedAt)}
        <ConnectedExtractMetadata itemInfo={props.item} availableActions={props.availableActions} />
        <ConnectedExtractTasksMetadata itemInfo={props.item} availableActions={props.availableActions} />
        <div style={{marginLeft: '24px'}}>
          <LabelWrapper itemInfo={props.item} isEager={true} kind={'chip'}
            wrapper={(e) =><HeaderLabelChipStyle>{e}</HeaderLabelChipStyle>} />
        </div>
      </React.Fragment>
    }
    descriptionElement={ItemDescription(props.item, props.openDetail, props.sanitizer)}
    spotlightActions={props.draft ? [] : [EditWorkbookAction]}
    bottomElement={FeatureFlags.webAuthoringAutoSaveEnabled && props.draft
      ? <WorkbookSpaceHeaderDraftBanner workbookContent={props.item} draftInfo={props.draft} />
      : null}
  />;
}
